export const InsertPanelLibrary = {
  flow: 'y',
  overflow: 'hidden auto',
  gap: 'Z2',
  fontSize: 'Z1',
  width: '100%',
  overflowY: 'auto',
  onEventComplete: async (el, s) => {
    const elData = el.data

    el.scope.__cache = {}
    s.replace(
      {
        loading: true
      },
      {
        preventListeners: true
      }
    )

    // The libraries THIS project links, each as an `owner/key` ref (the
    // project's own `useLibraries` record). A bare key can name several
    // owners' projects — the server answers it 409 `ambiguous_key` — so the
    // panel never sends one. It used to fetch the hardcoded legacy key
    // 'default.symbo.ls': on dev that key named nikoloza/default AND
    // system/default (2026-10-24).
    const libraries = await el.call('insertPanelLibraryRefs')
    const base = libraries.length ? libraries[0].ref : null
    const active = s.activeLibrary || base
    if (!active) {
      s.replace({ loading: false }, { preventListeners: true })
      return
    }

    let data
    if (elData[active]) {
      data = elData[active]
    } else {
      data = await el.call('fetchInsertPanelLibrary', active)
      elData[active] = data
    }
    if (!data) {
      s.replace({ loading: false }, { preventListeners: true })
      return
    }

    const exclList = ['members', 'usedByProjects', 'environments', 'project', 'versions']
    const exclOpts = {
      exclude: ['canvas', 'schema', ...exclList]
    }
    const dataExclOpts = {
      exclude: exclList
    }
    const projData = el.call('deepClone', el.getData(), exclOpts)

    data = el.call('deepClone', data, dataExclOpts)

    // Another library merges over the project's first linked one, as the
    // hardcoded default did.
    if (active !== base && elData[base]) {
      const defData = el.call('deepClone', elData[base], exclOpts)
      data = el.call('deepMerge', data, defData)
    }

    // USER-CODE-ORIGIN review N4: the library project stays AS STORED
    // (strings) — the shell never revives member-authored project code.

    // Usage
    const componentsCache = Object.values(data.components || {})
    el.scope.libraryComponentsCache = componentsCache

    window.setTimeout(() => {
      el.scope.__cache = el.call('deepMerge', projData, data)
      s.replace(
        {
          loading: false
        },
        {
          preventListeners: true
        }
      )
    }, 350)
  },
  scope: { __cache: {} },
  state: {
    // An `owner/key` ref; null = the project's first linked library.
    activeLibrary: null
  },
  data: {},
  LibraryNavbar: {},
  // DELETED: the `Nav` library-switcher row.
  //
  // Its `children` factory was `el.call('getSnippet', 'TEMPLATES_DATA',
  // 'array')`, and that call has never returned anything. `getSnippet` was
  // `packages/docs/functions/getSnippet.js` and went out with the whole docs
  // package in workspace 23a019f68 ("docs out, QuickEditor on canvas", April
  // 2026); nothing has registered the name since, and `el.call` on an
  // unregistered name THROWS rather than answering undefined. `TEMPLATES_DATA`
  // was never a snippet in this repository either — the docs package shipped
  // DOCS_SITEMAP and TUTORIALS and nothing else — so even before that deletion
  // the call hit getSnippet's own "snippet was not found" path. The row has
  // rendered zero library tabs at every commit, in every host, while costing a
  // minHeight-'D' bar of empty chrome and one lifecycle error per mount
  // (measured on the served UI-kit catalog, 2026-09-20).
  //
  // Registering the name instead would mean inventing the library list in
  // code, which is exactly what "never hardcode content" forbids. The real
  // source exists now: `el.call('insertPanelLibraryRefs')` answers the
  // project's linked libraries as `{ ref: 'owner/key', name }` rows. A
  // switcher sets `activeLibrary` to a row's `ref` — never a bare key (the
  // deleted row stored `projectPath.split('/')[1] + '.symbo.ls'`, which drops
  // the owner).
  P: {
    align: 'center',
    textAlign: 'center',
    margin: '-A auto C',
    color: 'placeholder',
    maxWidth: 'F1',
    flow: 'y',
    Lottie: {
      src: 'swipe-right.json',
      fontSize: 'B1',
      margin: '- - -X2'
    },
    Text: {
      text: '{{ editor.insert.dragHint | polyglot }}'
    }
  },
  LoadingGif: {
    hide: (el, s) => !s.loading
  },
  LibraryRows: {
    padding: 'Z',
    childrenAs: 'state',
    children: (el, s) => {
      if (!el.scope.__cache.canvas) return

      const canvasPages = el.scope.__cache.canvas.pages
      const data = el.scope.__cache.schema.components

      function unifyComponents(obj) {
        const allComponents = []

        // Iterate through each key in the object
        for (const key in obj) {
          if (obj[key].components && Array.isArray(obj[key].components)) {
            allComponents.push(...obj[key].components)
          }
        }

        return allComponents
      }

      const allDefined = unifyComponents(canvasPages)
      const filteredFromOtherPages = Object.keys(data).filter((item) => !allDefined.includes(item))

      const arr = [
        {
          title: (el) => el.call('polyglot', 'editor.chooseCanvas.default'),
          components: filteredFromOtherPages
        }
      ]

      const pages = s.CACHE.canvas.pages
      const exclPages = ['Archive', 'Working']
      const pagesArr = Object.keys(pages).filter((item) => !exclPages.includes(item))
      return arr.concat(pagesArr.map((v) => pages[v]))
    },
    childProps: {
      CaptionTitle: {
        Text: {
          text: '{{ title }}'
        }
      },
      Grid: {
        padding: '0',
        gap: 'A',
        margin: 'Z2 -Y -',
        templateColumns: 'repeat(4, 1fr)',
        childExtends: 'ComponentThumbnailIframe',
        childrenAs: 'state',
        children: (el, s) => {
          // const components = el.call('getProjectSchema', s.data)
          const components = s.components.map((v) => {
            const data = el.scope.__cache
            const schemaItem = data.schema.components[v]
            const dataItem = data.components[v]
            return (
              schemaItem &&
              dataItem && {
                ...schemaItem,
                value: dataItem
              }
            )
          })
          return components.filter((v) => v)
        }
      },
      Line: {
        margin: 'B1 -Z1'
      }
    },
    hide: (el, s) => s.loading
  }
}
